<template>
  <QrcodeVue :value="value" :size="size" :level="level" :margin="margin" />
</template>

<script setup>
const { default: QrcodeVue } = await import('qrcode.vue')

defineProps({
  value: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: 100,
  },
  level: {
    type: String,
    default: 'H',
  },
  /** Quiet zone in modules; 0 is qrcode.vue's own default. */
  margin: {
    type: Number,
    default: 0,
  },
})
</script>
